export default function FormClosed() {
  return <div>Ihr Formular wurde erfolgreich ausgefüllt.</div>;
}
